import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import { userTypes } from '../../../../types/user';

import { getUserData } from '../../../../user/selectors';

import { TranslatedCopy } from '../../../../intl/TranslatedCopy';
import { H1 } from '../../../../components';
import Select from '~COMPONENTS/formInputs/Select';
import Input from '~COMPONENTS/formInputs/Input';

import { required, maxLength35, maxLength55 } from '~APP_UTIL/formValidations';

import { isNAUser } from '../../../../util/constants';
import { RETURN_REASONS } from '../../constants';

export const OrderReturnsPageDetails = ({ referenceId, onFormValueUpdate, user }) => {
  const updateValue = (e, field) => onFormValueUpdate(e.target.defaultValue, field);

  const onChangeReason = e => updateValue(e, 'reasonCode');
  const onChangeComments = e => updateValue(e, 'comments');
  const onChangeReturnReference = e => updateValue(e, 'referenceId');

  return (
    <div className='flex-container center u-full-width bg-white'>
      <div className='orderReturns__section_page_form p6-sm pt7-sm pb7-sm u-full-width'>
        <H1>
          <TranslatedCopy id='orderreturns.enterDetails' />
        </H1>
        <div className='pt3-sm pb2-sm'>
          <div className='block'>
            <Field
              name='returnReason'
              component={Select}
              label={new TranslatedCopy({ id: 'orderreturns.returnReason' }).toString()}
              validate={[required]}
              options={
                isNAUser(user.country) ? RETURN_REASONS : RETURN_REASONS.filter(reason => reason.value !== '124')
              }
              normalize={option => option.value}
              clearable={false}
              forceDropdown
              ignoreCase
              required
              onBlur={onChangeReason}
            />
          </div>
          <div className='block'>
            <Field
              name='returnComments'
              type='text'
              component={Input}
              label={new TranslatedCopy({ id: 'orderreturns.returnComments' }).toString()}
              validate={[required, maxLength55]}
              required
              onBlur={onChangeComments}
            />
            <p className='text-color-warm-grey'>
              <TranslatedCopy id='orderreturns.returnReason.copy' />
            </p>
          </div>
          <div className='block'>
            <Field
              name='returnReference'
              type='text'
              component={Input}
              label={new TranslatedCopy({ id: 'orderreturns.returnReferenceId' }).toString()}
              placeholder={referenceId}
              validate={[required, maxLength35]}
              required
              onBlur={onChangeReturnReference}
            />
            <p className='text-color-warm-grey'>
              <TranslatedCopy id='orderreturns.returnReferenceId.copy' />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

OrderReturnsPageDetails.propTypes = {
  referenceId: PropTypes.string.isRequired,
  onFormValueUpdate: PropTypes.func.isRequired,
  user: userTypes
};

OrderReturnsPageDetails.defaultProps = {
  user: null
};

const mapStateToProps = state => ({
  user: getUserData(state)
});

const connector = connect(mapStateToProps, {});

export default connector(OrderReturnsPageDetails);
